/**
 * Make the header sticky
 * 
 * 
 */

export default class StickyHeader {
    private header: HTMLElement;
    private hero: HTMLElement;
    constructor(header: HTMLElement) {
        this.hero = (document.querySelector('.hero') || document.querySelector('.site-header'));
        if (header && this.hero) {
            this.header = header;
            window.addEventListener('scroll', (e) => this.stick(e));
        }
    }
    stick(e: Event) {
        const heroHeight = this.hero.offsetHeight;
        const scrolled = window.pageYOffset || document.body.scrollTop;
        if (scrolled > heroHeight/3) {
            document.body.classList.add('scrolled');
        } else {
            document.body.classList.remove('scrolled');
        }
    };
}